import { Facebook, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export function ShareButtons({ post, id = "share" }) {
  const url = `${window.location.origin}/api/share/blog/${post.slug}`;
  const text = `${post.title} – ${url}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied"); } catch { toast.error("Couldn't copy the link"); }
  };
  const btn = "inline-flex items-center gap-2 rounded-full border border-[#E2DACF] px-3 py-1.5 text-xs hover:bg-[#F0E8DE] transition-colors";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${id}-bar`}>
      <span className="text-xs text-[#5C6B63] mr-1">Share</span>
      <a className={btn} href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid={`${id}-whatsapp`}><MessageCircle size={13}/> WhatsApp</a>
      <a className={btn} href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" data-testid={`${id}-facebook`}><Facebook size={13}/> Facebook</a>
      <button className={btn} onClick={copy} data-testid={`${id}-copy`}><Link2 size={13}/> Copy link</button>
    </div>
  );
}
